import * as Devices from '../../devices';
import { CallStatusDefault } from '../../../models';
import { Item, State } from './model';

export const StateDefault: State = {
  deviceKey: '',
  items: [],
};

export const ItemDefault = (pk: Devices.PKey): Item => {
  return {
    ...Devices.DeviceDefault(pk),
    ...Devices.DeviceExtensionDefault,
    ...CallStatusDefault,
    historicalLogs: Devices.HistoricalDefault,
    getInfoCall: { ...CallStatusDefault }
  };
};
